import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function CreateMatch(match) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + match.tournament_id + '/matches', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({match: match})
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function UpdateMatch(id, match) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + match.tournament_id + '/matches/' + id, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({match: match})
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  } else {
    const resData = await response.json();
    return { status: response.status, data: resData.data }
  }
}

export async function GetMatch(tournamentId, matchId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + tournamentId + '/matches/' + matchId, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  const resData = await response.json();
  return resData.data;
}

export async function GetMatchResult(matchId) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/matches/' + matchId + '/result', {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status >= 500) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return { status: response.status, ...(await response.json()) };
}

export async function ListMatches(tournamentId, page) {
  const token = getAuthToken()

  if (token === null) {
    return { data: [], pagination: {} }
  }

  const url = config.apiBaseUrl + `/rest/admin/tournaments/` + tournamentId + `/matches` + (page ? `?page=${page}` : '')
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw new Response(JSON.stringify(
      { message: 'Could not fetch groups.' },
      {
        status: 500,
      }
    ));
  }

  return await response.json();
}

export async function DeleteMatch(tournamentId, matchId) {
  const response = await fetch(config.apiBaseUrl + `/rest/admin/tournaments/${tournamentId}/matches/${matchId}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (!response.ok) {
    return false;
  } else {
    return true;
  }
}

export async function ListMatchesPerDay(groupId, page, selectedDay) {
  const token = getAuthToken()

  if (token === null || groupId === null) {
    return {data: [], pagination: null }
  }

  const offset_minutes = new Date().getTimezoneOffset()
  const filterByDate = selectedDay ? ("&start_date=" + selectedDay + "&end_date=" + selectedDay + "&offset_minutes=" + offset_minutes) : ""
  const response = await fetch(config.apiBaseUrl + '/rest/matches/groups/' + groupId + '?page=' + page + filterByDate, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return await response.json();
}

export async function LoadMatchDays(groupId) {
  const token = getAuthToken()

  if (token === null || groupId === null) {
    return {dates: [], selected_date: null }
  }

  const offset_minutes = new Date().getTimezoneOffset()
  const response = await fetch(config.apiBaseUrl + '/rest/matches/groups/' + groupId + '/dates?offset_minutes=' + offset_minutes, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (!response.ok) {
    throw Response(JSON.stringify(
      { message: 'Could not fetch matches.' },
      { status: 500 }
    ));
  }

  return await response.json();
}
